import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Lisjilu"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M2.88037 3.13684V5.1846H4.92813",
  stroke: "#42526E",
  "stroke-width": "1.8",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M2.36865 8C2.36865 11.1101 4.88989 13.6313 8 13.6313C11.1101 13.6313 13.6313 11.1101 13.6313 8C13.6313 4.88989 11.1101 2.36865 8 2.36865C6.09979 2.36865 4.41939 3.30982 3.39955 4.75145",
  stroke: "#42526E",
  "stroke-width": "1.8",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8.16825 5.01123L8.16797 7.90169L10.1854 9.94265",
  stroke: "#42526E",
  "stroke-width": "1.8",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var lisjilu = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { lisjilu as default };
